export default __webpack_public_path__ + "static/media/backgroundVideo.5cf54063.png";